<template>
	<div class="remoteUpgrade mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">版本管理</div>
		</div>
		<div class="mainBot ">
			<div class="contentTop">
				<versionInformation @moduleOne="moduleOne"></versionInformation>
			</div>
			<div class="contentBot">
				<upgradeRecord ref="upgradeRecord" ></upgradeRecord>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
	import upgradeRecord from "./upgradeRecord/upgradeRecord.vue"
	import versionInformation from "./versionInformation/versionInformation.vue"
	export default {
		name: "remoteUpgrade",
		components: {
			upgradeRecord,
			versionInformation
		},
		data() {
			return {
				
			}
		},
		mounted() {
			this.$nextTick(() => {
			})
		},
		methods: {
			moduleOne(obj) {
				this.$refs.upgradeRecord.getData()
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	@import "./remoteUpgrade.scss";
</style>
